import { useCallback } from "react";
import { useDefaultLayout, useGroupRef } from "react-resizable-panels";
import type { Layout } from "react-resizable-panels";

interface UseResizablePanelsOptions {
  groupId: string;
  defaultLayout: Layout;
}

export const useResizablePanels = ({
  groupId,
  defaultLayout: fallbackLayout,
}: UseResizablePanelsOptions) => {
  const groupRef = useGroupRef();

  const { defaultLayout: savedLayout, onLayoutChanged } = useDefaultLayout({
    id: groupId,
  });

  const resetLayout = useCallback(() => {
    groupRef.current?.setLayout(fallbackLayout);
  }, [groupRef, fallbackLayout]);

  return {
    groupRef,
    defaultLayout: savedLayout ?? fallbackLayout,
    onLayoutChanged,
    resetLayout,
  };
};
